import styled from "@emotion/styled";

export const POSContainer = styled.div`
  padding: 20px;
  background: #f9fafb;
  min-height: 100vh;
`;

export const Header = styled.div`
  margin-bottom: 25px;
`;

export const MainContent = styled.div`
  flex: 3;
`;

export const Sidebar = styled.div`
  flex: 1.2;
  position: sticky;
  top: 20px;
`;

export const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: #f3f4f6;
  border-radius: 8px;
  margin-bottom: 20px;

  input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    font-size: 15px;
    padding: 8px 0;
  }
`;

export const SearchResults = styled.div`
  position: absolute;
  background: white;
  width: calc(60% - 40px);
  z-index: 10;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  max-height: 300px;
  overflow-y: auto;
  margin-top: -15px;
`;

export const SearchResultItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #f9fafb;
  }

  img {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    object-fit: cover;
  }

  div {
    flex: 1;
  }
`;

export const PrescriptionView = styled.div`
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f3f4f6;
`;

export const PrescriptionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
`;

export const PrescriptionImage = styled.img`
  width: 100%;
  height: 200px;
  border-radius: 8px;
  object-fit: cover;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.02);
  }
`;

export const CartList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
  min-height: 200px;
`;

export const CartItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #f3f4f6;
`;

export const QuantityControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 2px 8px;

  button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    color: #4b5563;
    padding: 0 4px;
    
    &:hover {
      color: #10b981;
    }
  }

  span {
    min-width: 20px;
    text-align: center;
    font-weight: 600;
  }
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  
  &:hover {
    background: #fee2e2;
  }
`;

export const Badge = styled.span`
  background: #dbeafe;
  color: #1e40af;
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 10px;
  font-weight: 600;
  margin-left: 5px;
  text-transform: uppercase;
`;

export const EmptyCart = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
  color: #9CA3AF;
  font-style: italic;
`;

export const Totals = styled.div`
  background: #f9fafb;
  padding: 15px;
  border-radius: 8px;
`;

export const Divider = styled.div`
  height: 1px;
  background: #e5e7eb;
  margin: 10px 0;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 25px;
  border-radius: 12px;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
`;
